(() => {
  if (window.__nutripeakSeznam) return;
  window.__nutripeakSeznam = true;
  let loading;
  let pageSent = false;
  const allowed = () => window.Shopify?.customerPrivacy?.marketingAllowed() === true && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const consent = () => ({ consent_mode: {
    ad_storage: allowed() ? 'granted' : 'denied',
    ad_user_data: 'denied',
    ad_personalization: allowed() ? 'granted' : 'denied',
    analytics_storage: allowed() ? 'granted' : 'denied',
    functionality_storage: 'denied'
  }});
  function load() {
    if (typeof window.SEM === 'function') return Promise.resolve();
    if (!loading) loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://l.seznam.cz/sul.js?id=hmty1tvwgkphj135ni3ml4tm';
      script.async = true;
      script.onerror = () => { loading = undefined; script.remove(); reject(new Error('Seznam loader unavailable')); };
      document.head.appendChild(script);
      let attempts = 0;
      const timer = setInterval(() => {
        if (typeof window.SEM === 'function') { clearInterval(timer); resolve(); }
        else if (++attempts >= 100) { clearInterval(timer); loading = undefined; reject(new Error('Seznam initialization timeout')); }
      }, 100);
    });
    return loading;
  }
  async function sync() {
    if (!allowed()) {
      if (typeof window.SEM === 'function') window.SEM('updateConsent', consent());
      return;
    }
    try {
      await load();
      window.SEM('updateConsent', consent());
      if (!allowed() || pageSent) return;
      window.SEM('track', 'PageView');
      pageSent = true;
    } catch (error) { console.warn('Nutripeak Seznam:', error.message); }
  }
  document.addEventListener('visitorConsentCollected', sync);
  if (window.Shopify?.customerPrivacy) sync();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) sync(); });
})();
